import io from 'socket.io-client'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { socketEmitStr } from '@/enums/systemMessages'
import { aes } from '@/utils/aes'
import globalEnv from '@/configs'
import { useAccountStore } from '@/stores/modules/account'
import type { messageData } from './type'
import { ElMessageBox } from 'element-plus'
import { useRoute, useRouter, type RouteLocation } from 'vue-router'
import { useTemCache } from '@/stores/modules/temCache'
import { useCallCenter } from './callCenter'
import { CallingCode, callCenterStatusEnum, dialingScenes } from '@/enums/callCenter'
import { RxkDialogMessageFun } from '@/components/common/RxkDialogMessage'
import { useTurnCall } from '@/hooks/callCenter/turnCall'
import { isEmptyObject, isJSON, isNullOrUndefOrEmpty } from '@/utils/is'
import type { CallUserInfoVO } from '@/types/callCenter/callCenter'
import MyGlobalEvent from '@/utils/bus/baseBus'
import { roundCallTaskdownloadFailResult } from '@/apis/callCenter/turnCall'
import { createLocalStorage } from '@/utils/cache'
import { excelExport } from '@/utils'
import { cloudGroupCallTaskdownloadFailResult } from '@/apis/callCenter/cloudGroupCall'
import { downloadFailResultApi } from '@/apis/callCenterConfig/blackValite'
import { useAuthStore } from '@/stores/modules/auth'
import { useCallScreen } from '@/components/business/callCenter/callScreen/src/hooks/useCallScreen'
import { useCall } from '@/hooks/callCenter/call'
import { useResource } from '@/hooks/useResource'
import { callCenterBtnCode } from '@/utils/preObjectManage/utils'
import { useGlobalFlow } from '@/stores/modules/globalFlow'
import { getFlowMsgType } from '@/views/layout/front/components/systemMessages/strategysExtend'
import { usePermissionStore } from '@/stores/modules/permission'
import { getSeaSelectApi } from '@/apis/highSeaManage'
import { useJumpAuth } from '@/hooks/useJumpAuth'
import { useGlobalStore } from '@/stores/modules/global'

import { usePayOrderInfo } from '@/stores/modules/pay'
import { downloadPersonUploadError } from '@/apis/systemManage/userManage'
import { useAudio } from '@/hooks/Audio/useAudio'
export const useSocketMsg = defineStore('socketMsg', () => {
  const usePermission = usePermissionStore()
  const globalStore = useGlobalStore()
  const systemListData = computed(() => {
    return usePermission.systemListData
  })
  // 是否有资料设置权限
  const infoConfigAuth = computed(() => {
    return !!unref(systemListData).find((item: any) => item.code === 'IC')
  })
  const route = useRoute()
  const router = useRouter()

  const temCache = useTemCache()
  const authStore = useAuthStore()
  const wsio = ref()
  const msgList = ref<messageData[]>([])
  const messageTotalNum = ref(0)
  const accountStore = useAccountStore()
  const callCenter = useCallCenter()
  const roundCallIntervalTime = ref(30)
  const roundCallInterval = ref()
  const turnCall = useTurnCall()
  const { getMenuAuth, getMenuInfo, getMenuInfoByCode, getAuthByMenuCode } = useResource()
  const { jumpToClueDetail, jumpToCustomerDetail } = useJumpAuth()

  function initSocket() {
    if (!accountStore.userInfo?.id) return

    const key = accountStore.userInfo?.id + '&' + 'PC'
    const a = aes.encrypt(key)
    // console.log(a, '加密')
    const b = aes.decrypt(a.slice(4))
    // console.log(b, '解密')
    // https://socket.jyunkj.cn
    // ws://192.168.30.148:52999
    wsio.value = io(globalEnv.websocketPath, {
      transports: ['websocket'],
      query: {
        key: aes.encrypt(key),
        k: accountStore.userInfo?.id + '-' + 'app'
      }
    })
    listenMessageNumber()
    listenSocketStatus()
    listenAuthentication()
    listenAccount()
    listenPerm()
    listenAccountDiabled()
    listenExport()
    listenCallCenter()
    listenHighSea()
    listenTurn()
    listenClue()
    listenEnterprise()
    listenClueCustomer()
    listenRecord()
    listenFollow()
    listenLimit()
    listenAuto()
    listenAutoCustomer()
    listenAutoStandCustomer()
    listenBlackImport()
    listenAppCall()
    listenAppCallStatus()
    listenAppCallSucess()
    listenServerTypeChange()
    listenExpireSeatSendMsg()
    listenCallTypeChange()
    listenPhoneCheckSendMsg()
    listenValueAddServiceProtocolMsg()
    listenRoundCallTaskImport()
    listenCodeBooking()
    listenRoundCallTaskAdd()
    listenRoundCallAckAndHangup()
    listenAppInitiateCall()
    listenCloudGroupCallTaskImport()
    listenLossAlarm()
    listenMobileCancel()
    listenMobileError()
    listenOrderCenterStatus()
    listenTransferDataProgress()
    listenShopAppointVisitDoor()
    listenShopAppointVisitDoorDelete()
    listenInvalidSignature()
    listenAddSignature()
    listenAutoAssign()
    listenSeaADDUpdate()
    listenRecyADDUpdate()
    listenSeaReceive()
    listenRecycling()
    listenRecycled()
    listenProductRemove()
    listenAuthenticationNotice()
    listenIdentifyCodeNotice()
    listenAssaRealNameUpdate()
    listenNewImportDown()
    listenRefund()
    listenRepeatCustom()
    listenOcrNotice()
    listenFlow()
    listenClueToCustomer()
    releaseCouponNotice()
    mallPlaceOrderNotice()
    mallOrderPayDoneNoticeNotice()
    inquiryManageAddNotice()
    listenStaffUpload()
    listenAddLayoutNotice()
    listenAutoEventNotice()
    listenErpRelate()
    listenErpUnRelate()
    listenErpNewOrder()
    listenErpAssetDetail()
    listenErpChannel()
    listenErpMargin()
    listenErpReceivableOneDay()
    listenErpReceivableExpire()
    listenErpReceivableOverdue()
    listenSystemNotice()
    listenTransferCusNotice()
    listErpBalanceThreshold()
    listErpBalanceWarningThreshold()
    listenMainAuthNotice()
    listenCustomer()
    listenTaskCard()
    listenEarlyRepay()
    listenMobilePhoneRcCallMark()
    listenAiSign()
    listenCPS()
    listenRetunVisit()
    listenOrderPhoneCheck()
    listenCityPrice()
    // customerDataChangeNotice()
    listenCustomerDataChange()
    listenaborClue()
  }
  // 播放提示音
  const { play } = useAudio()
  function setMsgList(data: messageData) {
    accountStore?.userInfo?.messageNotifyState && play()
    msgList.value.push(data)
    console.log(msgList.value, 'msgList.value')
  }
  function deleteMsgList(index: number) {
    msgList.value.splice(index, 1)
  }
  function clearMsgList() {
    msgList.value.splice(0, msgList.value.length + 1)
  }

  // 监听消息总数
  function listenMessageNumber() {
    wsio.value.on(socketEmitStr.EVENTTYPE_0, (data: any) => {
      // console.log(JSON.parse(data).messageSumNum, '消息总数wsio')
      messageTotalNum.value = JSON.parse(data).messageSumNum
    })
  }

  // 监听连接状态
  function listenSocketStatus() {
    wsio.value.on('status', (data: any) => {
      console.log(data, '连接成功wsio')
    })
    const heartInterval = setInterval(() => {
      console.log('发送心跳包')
      wsio.value.emit('heart')
    }, 54000)

    wsio.value.on('disconnect', (data: any) => {
      console.log(data, '断开连接wsio')
      clearInterval(heartInterval)
    })
    wsio.value.on('connect_error', (data: any) => {
      console.log(data, '连接错误wsio')
    })
  }

  // 关闭socket
  function closeSocket() {
    if (wsio.value) wsio.value.close()
  }

  function goToMenu(data: any, commontitle?: string) {
    if (!data.count) data.count = data.sum
    if (!data.seaType) data.seaType = data.orderType
    // 线索
    if (+data.seaType === 1) {
      if (!getMenuAuth('ClueManage')) {
        ElMessage.error('暂无权限，请联系管理员开通权限')
        return
      }
      if (+data.count === 1) {
        jumpToClueDetail(data)
      } else if (+data.count > 1) {
        // 线索管理列表
        temCache.saveData('clueParams', {
          id: data.objectId.split(','), // fieldCodes:values
          title: commontitle,
          chooseNum: +data.count
        })
        router.push('/clueManage')
      }
    } else {
      // 客户
      if (!getMenuAuth('CustomerManage')) {
        ElMessage.error('暂无权限，请联系管理员开通权限')
        return
      }
      if (+data.count === 1) {
        jumpToCustomerDetail(data)
      } else if (+data.count > 1) {
        // 客户管理列表
        temCache.saveData('customerParams', {
          id: data.objectId.split(','), // fieldCodes:values
          title: commontitle,
          chooseNum: +data.count
        })
        router.push('/customerManage')
      }
    }
  }

  async function clickToList(data: any) {
    if (!data.seaType) data.seaType = data.orderType
    // 跳转公海列表
    if (+data.seaType === 0) {
      const seaList = await getSeaSelectApi({ operation: 1 })
      if (!getMenuAuth('HighSeaManage')) {
        ElMessage.error('暂无权限，请联系管理员开通权限')
        return
      }
      const item = seaList.find((v: any) => data.objectId === v.id)
      if (!item) {
        router.push('/403')
        return
      }
      temCache.saveData('highSeaId', { id: data.objectId })
      router.push('/highSeaManage')
    }

    // 跳转线索列表
    if (+data.seaType === 1) {
      const seaList = await getSeaSelectApi({ operation: 1, seaType: 1 })
      if (!getMenuAuth('ClueHighSeasManage')) {
        ElMessage.error('暂无权限，请联系管理员开通权限')
        return
      }
      const item = seaList.find((v: any) => data.objectId === v.id)
      if (!item) {
        router.push('/403')
        return
      }
      temCache.saveData('clueHighSeaId', { id: data.objectId })
      router.push('/clueHighSeasManage')
    }
  }

  // 监听验权失败
  function listenAuthentication() {
    wsio.value.on('authentication_failed', (data: any) => {
      console.log(data, '鉴权失败wsio')
    })
  }
  function logout() {
    console.log('监听重复登录')
    accountStore.logout()
    ElMessageBox.alert('当前账号已在其他地方登陆，您已被迫下线！', '提示', {
      confirmButtonText: '我知道了'
    })
  }
  // 监听重复登录
  function listenAccount() {
    wsio.value.on(socketEmitStr.server_push_event_repeat_login, logout)
  }
  //  关闭监听
  function closeListenAccount() {
    wsio.value.off(socketEmitStr.server_push_event_repeat_login, logout)
  }

  // 监听权限变更
  function listenPerm() {
    wsio.value.on(socketEmitStr.server_push_event_permission_change, (data: any) => {
      console.log('监听权限变更', data)
    })
  }

  // 监听账号被禁用
  function listenAccountDiabled() {
    wsio.value.on(socketEmitStr.server_push_event_account_disable, (data: any) => {
      console.log('监听账号被禁用', data)
    })
  }

  // 监听导出事件
  function listenExport() {
    wsio.value.on(socketEmitStr.event_export_finish, (data: any) => {
      console.log('监听导出事件', data)
    })
  }

  // 监听打开呼叫中心
  function listenCallCenter() {
    wsio.value.on(socketEmitStr.event_change_seat_switch, (data: any) => {
      console.log('监听打开呼叫中心', data)
    })
  }

  // 公海分配客户给员工
  function listenHighSea() {
    wsio.value.on(socketEmitStr.high_seas_allocates_customers_to_employees, (dataStr: any) => {
      console.log('公海分配客户给员工', dataStr)

      const data = JSON.parse(dataStr)
      const title = `${data.operatorName}分配的${data.count}个${
        +data.seaType === 1 ? '线索' : '客户'
      }`
      setMsgList({
        content: data.content,
        fn: () => goToMenu(data, title),
        msgId: data.msgId
      })
    })
  }

  // 线索转客户
  function listenClueToCustomer() {
    wsio.value.on(socketEmitStr.clue_convert_to_customers_event, (dataStr: any) => {
      console.log('线索转客户', dataStr)

      const data = JSON.parse(dataStr)

      setMsgList({
        content: data.content,
        fn: () => {
          // 客户
          if (!getMenuAuth('CustomerManage')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }

          // 客户管理列表
          temCache.saveData('customerParams', {
            id: data.objectId.split(','), // fieldCodes:values
            title: `${data.realName}分派了${data.count}个线索`,
            chooseNum: +data.count
          })
          router.push('/customerManage')
        },
        msgId: data.msgId
      })
    })
  }

  // 移交客户给员工
  function listenTurn() {
    wsio.value.on(socketEmitStr.turn_over_customers_to_employees, (dataStr: any) => {
      console.log('移交客户给员工', dataStr)

      const data = JSON.parse(dataStr)
      // const num = data.customerId.split(',').length
      // let label = `${data.operatorName}移交的${num}个客户`

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId
      })
    })
  }

  // 线索池派发客户到员工线索池
  function listenClue() {
    wsio.value.on(socketEmitStr.turn_over_customers_to_employees, (dataStr: any) => {
      console.log('线索池派发客户到员工线索池', dataStr)

      const data = JSON.parse(dataStr)
      // const num = data.customerId.split(',').length
      // let label = `${data.operatorName}分派的${num}条线索`

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId
      })
    })
  }

  // 企业认证
  function listenEnterprise() {
    wsio.value.on(socketEmitStr.event_eqb_identity_success_send_msg, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      if (data.notice) {
        setMsgList({
          content: data.content,
          fn: () => {}
        })
      }
      temCache.saveData('identity_success_send_msg', data.msg)
    })
  }

  // 线索池派发客户到员工客户池
  function listenClueCustomer() {
    wsio.value.on(
      socketEmitStr.clue_pool_distributes_customers_to_employee_customer_pool,
      (dataStr: any) => {
        console.log('线索池派发客户到员工客户池', dataStr)

        const data = JSON.parse(dataStr)
        // const num = data.customerId.split(',').length
        // let label = `${data.operatorName}分派的${num}条客户`

        setMsgList({
          content: data.content,
          fn: () => {},
          msgId: data.msgId
        })
      }
    )
  }

  // 成功提交跟进记录评价
  function listenRecord() {
    wsio.value.on(socketEmitStr.successfully_submit_follow_up_record_evaluation, (dataStr: any) => {
      const newResponseString = dataStr.replace(/"customerId":(\d+)/, '"customerId": "$1"')
      const data = JSON.parse(newResponseString)

      setMsgList({
        content: data.content,
        fn: () => {
          const { customDetail } = useCallScreen()
          const resolvePath = (path: RouteLocation & { href: string }) => {
            if (path.path === route.path) {
              MyGlobalEvent.$emit('refreshFollow')
            } else {
              router.push(path)
            }
          }
          customDetail(data.customerId, data.customerName, resolvePath)
        },
        msgId: data.msgId
      })
    })
  }
  // 已到跟进计划
  function listenFollow() {
    wsio.value.on(socketEmitStr.follow_up_plan_is_in_place, (dataStr: any) => {
      console.log('已到跟进计划', dataStr)

      const data = JSON.parse(dataStr)
      const content = JSON.parse(data.content)
      setMsgList({
        content: content.content,
        fn: () => {
          const { goDetail } = useCallScreen()
          goDetail(data.customerId, content.customerName)
        },
        msgId: data.msgId
      })
    })
  }

  // 自动派发、客户列表表格导入、移交、公海分配、回收站还原客户给某员工
  function listenLimit() {
    wsio.value.on(socketEmitStr.the_employee_has_reached_his_limit, (data: any) => {
      console.log('自动派发、客户列表表格导入、移交、公海分配、回收站还原客户给某员工', data)

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId
      })
    })
  }

  // 自动派发达员工上限，未配备备用员工，进入主账号线索池的通知
  function listenAuto() {
    wsio.value.on(
      socketEmitStr.auto_distributes_limit_of_customer_limit_to_notice_user,
      (dataStr: any) => {
        console.log('自动派发达员工上限，未配备备用员工，进入主账号线索池的通知', dataStr)

        const data = JSON.parse(dataStr)
        // const num = data.customerId.split(',').length
        // let label = `系统派发的${num}条线索`

        setMsgList({
          content: data.content,
          fn: () => {},
          msgId: data.msgId
        })
      }
    )
  }

  // 自动派发到客户池通知员工
  function listenAutoCustomer() {
    wsio.value.on(socketEmitStr.auto_distributes_no_limit_of_customer_limit, (dataStr: any) => {
      console.log('自动派发到客户池通知员工', dataStr)

      const data = JSON.parse(dataStr)
      // const label = '系统自动派发的客户线索'

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId
      })
    })
  }

  // 自动派发到客户池通知备用员工
  function listenAutoStandCustomer() {
    wsio.value.on(
      socketEmitStr.auto_distributes_limit_of_customer_limit_to_stand_by_user,
      (dataStr: any) => {
        console.log('自动派发到客户池通知备用员工', dataStr)

        const data = JSON.parse(dataStr)
        // const label = '系统自动派发的客户线索'

        setMsgList({
          content: data.content,
          fn: () => {},
          msgId: data.msgId
        })
      }
    )
  }

  // 监听黑名单上传结果
  function listenBlackImport() {
    wsio.value.on(socketEmitStr.event_import_blacklist_complete, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, '监听黑名单上传结果')
      const blackListValidateImportInfo = createLocalStorage().get('blackListValidateImportInfo')
      // MyGlobalEvent.$emit('closeLoading')
      // MyGlobalEvent.$emit('refreshTable', blackListValidateImportInfo || '')
      console.log(data)
      let text = '查看'
      let src = ''
      let fn = () => {}
      if (data.hasFailed) {
        text = '下载导入失败数据'
        src = '部分号码导入失败，请点击下载导入失败数据。'
        fn = () => {
          excelExport(`${downloadFailResultApi}/${blackListValidateImportInfo}`, {})
          createLocalStorage().remove('blackListValidateImportInfo')
        }
      } else {
        src = '全部号码已导入成功，请点击查看按钮查看已导入数据'
        fn = () => {
          router.replace({
            path: '/callCenterConfig/blacklistValidate'
          })
          callCenter.setIsCheckPhoneDetail(true)
          createLocalStorage().remove('blackListValidateImportInfo')
        }
      }
      setMsgList({
        content: src,
        fn,
        text
      })
    })
  }

  // 监听唤起APP呼叫
  function listenAppCall() {
    wsio.value.on(socketEmitStr.evoke_mobile_phone_dial_event, (dataStr: any) => {
      console.log(dataStr, '监听唤起APP呼叫')
      roundCallIntervalTime.value = 30
      // 如果实在轮呼中，开启倒计时30S，30S后没收到呼叫消息，关闭轮呼
      if (callCenter.dialingScenes === dialingScenes.turnCallApp) {
        roundCallInterval.value && clearInterval(roundCallInterval.value)
        roundCallInterval.value = setInterval(() => {
          roundCallIntervalTime.value--
          console.log(roundCallIntervalTime.value)
          if (roundCallIntervalTime.value === 0) {
            // 终止轮呼
            clearInterval(roundCallInterval.value)
            RxkDialogMessageFun({
              messageContent: {
                // @ts-ignore
                isDefault: true,
                mainContent: '唤起手机端呼叫失败，请检查手机端：',
                descContent: '等待手机响应超时，轮呼开关已关闭，如需继续轮呼请再次打开开关',
                confirmText: '确定',
                type: 'warn',
                title: '提示',
                showCancelBtn: false,
                showConfirmBtn: true,
                showHeaderTBorder: true, // 是否显示头部操作栏底部边框
                showFooterBBorder: true // 是否显示底部操作栏顶部边框
              },
              visible: true,
              closeOnClickModal: false
            })
            turnCall.shutdown()
          }
        }, 1000)
      }
    })
  }

  // 监听APP唤醒失败
  function listenAppCallStatus() {
    wsio.value.on(socketEmitStr.evoke_mobile_phone_dial_failed_event, (dataStr: any) => {
      console.log(dataStr, '监听APP唤醒失败')
      roundCallInterval.value && clearInterval(roundCallInterval.value)
      RxkDialogMessageFun({
        messageContent: {
          // @ts-ignore
          isDefault: true,
          mainContent: '唤起手机端呼叫失败，请检查手机端：',
          descContent: '是否已开启【电脑端唤起手机呼叫】，同时保持手机亮屏和打开APP软件',
          confirmText: '确定',
          type: 'warn',
          title: '提示',
          showCancelBtn: false,
          showConfirmBtn: true,
          showHeaderTBorder: true, // 是否显示头部操作栏底部边框
          showFooterBBorder: true // 是否显示底部操作栏顶部边框
        },
        visible: true,
        closeOnClickModal: false
      })
      if (callCenter.dialingScenes === dialingScenes.turnCallApp) {
        // 终止轮呼
        turnCall.shutdown()
      }
    })
  }

  // 监听APP唤醒成功
  function listenAppCallSucess() {
    wsio.value.on(socketEmitStr.evoke_mobile_phone_dial_success_event, (_dataStr: any) => {
      // const data = JSON.parse(dataStr)
      // console.log(data, '监听APP唤醒成功')
      clearInterval(roundCallInterval.value)
      RxkDialogMessageFun({
        messageContent: {
          // @ts-ignore
          isDefault: true,
          mainContent: '已唤起手机端呼叫，请在手机端打开APP软件进行通话。',
          showCancelBtn: false,
          confirmText: '确定',
          type: 'warn',
          title: '提示',
          showConfirmBtn: true,
          showHeaderTBorder: true, // 是否显示头部操作栏底部边框
          showFooterBBorder: true // 是否显示底部操作栏顶部边框
        },
        visible: true,
        closeOnClickModal: false
      })
    })
  }

  // 监听admin切换呼叫中心线路类型serverType
  function listenServerTypeChange() {
    wsio.value.on(socketEmitStr.call_center_admin_change_server_type_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听admin切换呼叫中心线路类型serverType')
    })
  }

  // 坐席到期提醒
  function listenExpireSeatSendMsg() {
    wsio.value.on(socketEmitStr.event_expire_seat_send_msg, (dataStr: any) => {
      let data = null
      try {
        data = JSON.parse(dataStr)
      } catch (error) {
        data = { content: dataStr }
      }
      console.log(data, '坐席到期提醒')
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 监听机构呼叫方式变更
  function listenCallTypeChange() {
    wsio.value.on(socketEmitStr.event_change_call_type_config, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, '监听机构呼叫方式变更')
      // 重新初始化呼叫中心
      callCenter.initCallCenter()
    })
  }

  // 监听号码检验服务次数通知
  function listenPhoneCheckSendMsg() {
    wsio.value.on(socketEmitStr.organ_phone_check_num_limit_send_msg, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听号码检验服务次数通知')

      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 监听增值服务协议通知
  function listenValueAddServiceProtocolMsg() {
    wsio.value.on(socketEmitStr.event_msg_type_520, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听增值服务协议通知')

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId
      })
    })
  }

  // 监听轮呼任务号码导入结果
  function listenRoundCallTaskImport() {
    wsio.value.on(socketEmitStr.call_round_task_number_import_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, '监听轮呼任务号码导入结果')
      const roundCallTaskImportInfo = createLocalStorage().get('roundCallTaskImportInfo')
      MyGlobalEvent.$emit('closeLoading')
      MyGlobalEvent.$emit('refreshTable', roundCallTaskImportInfo?.tmpTaskId || '')
      console.log(data)
      let text = '查看'
      let src = ''
      let fn = () => {}
      if (data.hasFailed) {
        text = '下载导入失败数据'
        src = '部分号码导入失败，请点击下载导入失败数据。'
        fn = () => {
          excelExport(`${roundCallTaskdownloadFailResult}/${roundCallTaskImportInfo.fairKey}`, {})
          createLocalStorage().remove('roundCallTaskImportInfo')
        }
      } else {
        text = '确定'
        src = '轮呼任务号码已导入成功'
        createLocalStorage().remove('roundCallTaskImportInfo')
      }
      setMsgList({
        content: src,
        fn,
        text
      })
    })
  }

  // 监听扫码预约的相关消息
  function listenCodeBooking() {
    wsio.value.on(socketEmitStr.event_msg_type_500, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听扫码预约的相关消息')

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId
      })
    })
  }

  // 监听轮呼任务新建推送
  function listenRoundCallTaskAdd() {
    wsio.value.on(socketEmitStr.call_round_task_create_edit_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, '监听轮呼任务新建推送')
      let fn = () => {}
      fn = () => {
        if (!getMenuAuth('TurnCallManage')) {
          ElMessage.error('暂无权限，请联系管理员开通权限')
          return
        }
        router.replace(
          `/callCenter/turnCallDetail?id=${data.taskId}&taskId=${data.taskId}&realName=${data.taskName}`
        )
      }
      setMsgList({
        content: `${data.content}${data.successSize}条通话名单，请及时跟进！`,
        fn,
        text: ''
      })
    })
  }

  // 监听PC唤起APP轮呼挂断通知
  function listenRoundCallAckAndHangup() {
    wsio.value.on(socketEmitStr.event_user_round_call_ack_and_hangup, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, '监听PC唤起APP轮呼挂断通知')
      roundCallInterval.value && clearInterval(roundCallInterval.value)
      callCenter.setFloadMenu(true)
      callCenter.setCallingCode(CallingCode.CEND)
      callCenter.setCallCenterStatus(callCenterStatusEnum.READY)
      callCenter.setShowCallScreen(false)
      callCenter.setCallWriteFollowTag(false)
      MyGlobalEvent.$emit('roundCallDetailRefresh')
      MyGlobalEvent.$emit('roundCallTableRefresh')
      // dispatch('setIsRefreshTable', true)
      // dispatch('setCallStatus', 'CEND')
    })
  }

  // 监听APP发起轮呼呼叫-将轮呼信息缓存起
  function listenAppInitiateCall() {
    wsio.value.on(socketEmitStr.evoke_mobile_phone_rc_initiate_call, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, '监听APP发起轮呼呼叫')
      const useCallScreenHooks = useCallScreen()
      const callHoosk = useCall()
      roundCallInterval.value && clearInterval(roundCallInterval.value)
      const contactInfo = JSON.parse(data.contactInfo)
      console.log(contactInfo, 'APPcontactInfo')
      callCenter.setCallCenterStatus(callCenterStatusEnum.CALLING)
      callCenter.setCallingCode(CallingCode.CBEGIN)
      callCenter.setShowCallScreen(true)
      callCenter.setCallWriteFollowTag(false)
      const callCenterInfo: CallUserInfoVO = {
        title: {
          ...contactInfo,
          linkName: '',
          plaintextPhone: contactInfo.plaintextPhoneNum,
          realName: contactInfo.name,
          desensitizePhoneNum: contactInfo.phone,
          callType: data.callType,
          unknow: false,
          roundCustomerId: contactInfo.id
        },
        gcId: data.gcId || '',
        userList: [],
        localDialId: data.localDialId || ''
      }
      console.log(
        '%cfollowUserId',
        'color: red;font-size: 5em',
        contactInfo?.contactInfoVO?.followUserId
      )
      console.log('%cuserInfo', 'color: red;font-size: 5em', accountStore.userInfo?.id)
      if (
        contactInfo.relateShopOrderId === 0 ||
        isNullOrUndefOrEmpty(contactInfo.relateShopOrderId) ||
        isNullOrUndefOrEmpty(contactInfo.contactInfoVO)
      ) {
        // 陌生客户
        if (contactInfo?.contactInfoVO?.followUserId !== accountStore.userInfo?.id) {
          callCenterInfo!.title!.unknow = true
          callCenterInfo!.title!.dataFrom = 1
          useCallScreenHooks.callAddCustom(callCenterInfo)
          callCenter.setShowCallScreen(false)
        }
      } else {
        callCenterInfo!.title!.unknow = false
        ;(callCenterInfo!.title!.objectId = contactInfo.relateShopOrderId),
          (callCenterInfo!.title!.dataFrom =
            contactInfo.dataFrom || contactInfo.contactInfoVO?.dataFrom),
          (callCenterInfo!.title!.belongOpenSeaId = contactInfo.contactInfoVO?.belongOpenSeaId),
          (callCenterInfo!.title!.desensitizePhoneNum =
            contactInfo.contactInfoVO?.desensitizePhoneNum)
        callCenterInfo!.title!.customerId = contactInfo.contactInfoVO?.customerId
        callCenterInfo!.title!.linkName = contactInfo.name

        if (contactInfo.contactInfoVO?.dataFrom === 1) {
          if (contactInfo?.contactInfoVO?.followUserId !== accountStore.userInfo?.id) {
            callCenterInfo!.title!.unknow = true
            useCallScreenHooks.callAddCustom(callCenterInfo)
            callCenter.setShowCallScreen(false)
          } else {
            callCenter.setShowCallScreen(false)
            // 跳转详情页
            callHoosk.jumpToDetail(contactInfo.relateShopOrderId, contactInfo.name)
          }
        }
      }
      callCenter.setCallUserInfo(callCenterInfo)
    })
  }

  // 监听云群呼任务号码导入结果（表格带入、公海导入）
  function listenCloudGroupCallTaskImport() {
    wsio.value.on(
      socketEmitStr.call_center_group_call_tmp_contact_import_result,
      (dataStr: any) => {
        const groupCallTaskImportInfo = createLocalStorage().get('groupCallTaskImportInfo')
        MyGlobalEvent.$emit('closeLoading')
        MyGlobalEvent.$emit('refreshTable')
        let content = ''
        let text = ''
        let fn = () => {}
        console.log(dataStr, '监听云群呼任务号码导入结果（表格带入、公海导入）')
        if (Number(dataStr) === 1) {
          text = '下载导入失败数据'
          content = '部分号码导入失败，请点击下载导入失败数据。'
          fn = () => {
            excelExport(
              `${cloudGroupCallTaskdownloadFailResult}/${groupCallTaskImportInfo.ticket}`,
              {}
            )
            createLocalStorage().remove('groupCallTaskImportInfo')
          }
        } else {
          text = '确定'
          content = '号码已导入成功'
          createLocalStorage().remove('groupCallTaskImportInfo')
        }
        setMsgList({
          content: content,
          fn: fn,
          text: text
        })
      }
    )
  }

  // 监听话损告警
  function listenLossAlarm() {
    wsio.value.on(socketEmitStr.group_call_arrived_threshold_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      const taskInfo = JSON.parse(data.task)
      const fn = () => {
        getMenuInfo('CC', 'callCenter/cloudGroupCall', false).then(res => {
          if (
            !res?.resourceList?.find?.(
              (ele: { code: string }) => ele?.code === callCenterBtnCode.GROUP_CALL_DELETE
            )
          ) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return false
          }
        })
        router.push(
          `/callCenter/cloudGroupCallDetail?id=${taskInfo.id}&taskId=${taskInfo.id}&outPerms=true&realName=${taskInfo.taskName}`
        )
      }
      console.log(data, '监听话损告警', taskInfo)

      setMsgList({
        content: data.content,
        fn: fn,
        text: '查看'
      })
    })
  }

  // 监听PC唤起APP轮呼，APP端取消
  function listenMobileCancel() {
    wsio.value.on(socketEmitStr.evoke_mobile_phone_dial_cancel_event, (_dataStr: any) => {
      // const data = JSON.parse(dataStr) //返回的不是json
      // const data = JSON.parse(dataStr)
      // console.log(data, '监听PC唤起APP轮呼，APP端取消')
      roundCallInterval.value && clearInterval(roundCallInterval.value)
      turnCall.showCountDown()
    })
  }

  // 监听PC唤起APP轮呼，APP终止轮呼
  function listenMobileError() {
    wsio.value.on(socketEmitStr.evoke_mobile_rc_error_event, (dataStr: any) => {
      console.log(dataStr, '监听PC唤起APP轮呼，APP终止轮呼')
      roundCallInterval.value && clearInterval(roundCallInterval.value)
      ElMessage.error('呼叫失败，轮呼已终止')
      turnCall.shutdown()
      callCenter.setCallingCode(CallingCode.CEND)
      callCenter.setCallCenterStatus(callCenterStatusEnum.READY)
    })
  }

  // 做单中心状态变更
  function listenOrderCenterStatus() {
    wsio.value.on(socketEmitStr.task_phase_change_notification, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '做单中心状态变更')

      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 离职人员移交数据进度
  function listenTransferDataProgress() {
    wsio.value.on(socketEmitStr.async_move_to_data, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '离职人员移交数据进度')

      setMsgList({
        content: data.content
      })
    })
  }

  // 预约上门  分配谈单人
  function listenShopAppointVisitDoor() {
    wsio.value.on(socketEmitStr.shop_appoint_visit_door, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '预约上门')

      setMsgList({
        content: data.content,
        fn: () => {
          if (~~data.msgType === 804) {
            const { tableCode, id } = getMenuInfoByCode('AppointVisit')?.[0] || {}
            router.push(
              `/appointVisitDetail?id=${data.objectId}&tableCode=${tableCode}&menuId=${id}`
            )
          } else {
            if (!getMenuAuth('AppointVisit')) {
              ElMessage.error('暂无权限')
              return
            }
            router.push('/appointVisit')
          }
        }
      })
    })
  }

  // 删除预约上门
  function listenShopAppointVisitDoorDelete() {
    wsio.value.on(socketEmitStr.EVENTTYPE_30, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '删除预约上门')

      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 签单作废
  function listenInvalidSignature() {
    wsio.value.on(socketEmitStr.sign_discard_notice, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '签单作废')

      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 签单新增
  function listenAddSignature() {
    wsio.value.on(socketEmitStr.add_sign_bill_notice, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '签单新增')

      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('SignManage')) {
            ElMessage.error('暂无权限')
            return
          }
          router.push('/signManage')
        }
      })
    })
  }

  // 监听公海自动分派
  function listenAutoAssign() {
    wsio.value.on(socketEmitStr.auto_assign_seas_to_employee, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听公海自动分派')
      const title = `系统派发的${data.count}个${+data.seaType === 1 ? '线索' : '客户'}`
      setMsgList({
        content: data.content,
        fn: () => goToMenu(data, title)
      })
    })
  }

  // 公海新增编辑
  function listenSeaADDUpdate() {
    wsio.value.on(socketEmitStr.open_sea_add_update_admin_member_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '公海新增编辑')

      // setMsgList({
      //   content: data.content,
      //   fn: () => { },
      // })
    })
  }

  // 回收规则新增编辑
  function listenRecyADDUpdate() {
    wsio.value.on(socketEmitStr.open_sea_add_update_recycle_rules_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '回收规则新增编辑')

      // setMsgList({
      //   content: data.content
      // })
    })
  }

  // 监听公海领取客户/线索
  function listenSeaReceive() {
    wsio.value.on(socketEmitStr.open_sea_get_customers_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听公海领取客户')
      const title = `${data.operatorName}领取的${data.count}个${
        +data.seaType === 1 ? '线索' : '客户'
      }`

      setMsgList({
        content: data.content,
        fn: () => goToMenu(data, title)
      })
    })
  }

  // 客户已被回收 (加)
  function listenRecycled() {
    wsio.value.on(socketEmitStr.customer_notified_recycled, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      data.objectId = data.openSeaId
      console.log(data, '客户已被回收')

      setMsgList({
        content: data.content,
        fn: () => clickToList(data)
      })
    })
  }

  // 客户即将回收 (改)
  function listenRecycling() {
    wsio.value.on(socketEmitStr.customer_notified_impending_recycling, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      console.log(data, 99999)
      console.log(data, '客户即将回收')
      let fn = () => {}
      // 1 客户跳详情
      if (+data.sum === 1) {
        fn = () => goToMenu(data)
      } else {
        fn = () => goToMenu(data)
      }
      // 多个 待办事项-将掉公海客户

      setMsgList({
        content: data.content,
        fn
      })
    })
  }

  // 产品下架
  function listenProductRemove() {
    wsio.value.on(socketEmitStr.event_identity_change_offline_product, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '产品下架')

      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 监听实名认证通知
  function listenAuthenticationNotice() {
    wsio.value.on(socketEmitStr.event_identity_change_offline_product, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听实名认证通知')

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId,
        mainTitle: '实名认证消息',
        showCheck: data.auditStatus !== '200' ? 'true' : 'false'
      })
    })
  }
  // 监听ocr识别通知
  function listenOcrNotice() {
    wsio.value.on(socketEmitStr.user_auth_notice, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {},
        mainTitle: '实名认证消息',
        showCheck: 'false'
      })
    })
  }

  // 监听人脸识别通知
  function listenIdentifyCodeNotice() {
    wsio.value.on(socketEmitStr.saas_ocr_success_event, (dataStr: any) => {
      console.log(dataStr, 'dataStr')

      const data = JSON.parse(dataStr)
      //  0消息关闭 1消息打开
      if (data.notice) {
        setMsgList({
          content: '实名认证通过',
          fn: () => {},
          mainTitle: '实名认证消息',
          showCheck: 'false'
        })
      }
      authStore.accountAuthData = data
    })
  }

  // 监听姓名或电话更新事件
  function listenAssaRealNameUpdate() {
    wsio.value.on(socketEmitStr.saas_real_name_update_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听姓名或电话更新事件')

      setMsgList({
        content: data.content,
        fn: () => {
          if (infoConfigAuth) {
            router.push('/accountConfig')
          } else {
            ElMessage.error('暂无权限，请联系管理员开通权限')
          }
        },
        mainTitle: '实名认证消息'
      })
    })
  }

  // 监听新版导入完毕事件
  function listenNewImportDown() {
    wsio.value.on(socketEmitStr.saas_import_success_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听新版导入完毕事件')

      setMsgList({
        content: data.content,
        fn: () => {
          temCache.saveData('showImportTask', true)
        }
      })
    })
  }

  // 退款通知
  function listenRefund() {
    wsio.value.on(socketEmitStr.refund_notification, (dataStr: any) => {
      console.log(dataStr, '退款通知')

      setMsgList({
        content: dataStr,
        mainTitle: '退款通知',
        showCheck: 'false'
      })
    })
  }

  // 监听撞库
  function listenRepeatCustom() {
    wsio.value.on(socketEmitStr.event_repeat_custom, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      console.log(data, '监听撞库')

      setMsgList({
        content: data.content,
        fn: () => {
          if (data?.orderType === '1') {
            // 数据穿透到线索管理
            // 判断权限
            if (!getMenuAuth('ClueManage')) {
              ElMessage.error('暂无权限')
              return
            }
            temCache.saveData('clueParams', {
              chooseNum: 1,
              title: '线索记录',
              id: [data?.objectId]
            })
            router.push('/clueManage')
          } else {
            // 数据穿透到客户管理
            if (!getMenuAuth('CustomerManage')) {
              ElMessage.error('暂无权限')
              return
            }
            temCache.saveData('customerParams', {
              chooseNum: 1,
              title: '线索记录',
              id: [data?.objectId]
            })
            router.push('/customerManage')
          }
        }
      })
    })
  }

  // 监听审批、业务流程
  function listenFlow() {
    wsio.value.on(socketEmitStr.approval_notification, (dataStr: any) => {
      console.log('审批流程', dataStr)

      const data = JSON.parse(dataStr)
      // const num = data.customerId.split(',').length
      // let label = `${data.operatorName}移交的${num}个客户`

      setMsgList({
        content: data.content,
        data: data,
        fn: () => {
          const formatData = getFlowMsgType(data, data.msgType)
          const { init } = useGlobalFlow()
          init({
            flowId: formatData.taskGuid,
            processId: formatData.processId,
            type: formatData.flowType
          })
        },
        msgId: data.msgId
      })
    })
  }
  // 优惠券发放成功消息
  function releaseCouponNotice() {
    wsio.value.on(socketEmitStr.gift_coupon_notice, (dataStr: any) => {
      console.log('优惠券消息', dataStr)

      const data = JSON.parse(dataStr)
      console.log('优惠券消息', data)
      const text = '查看'
      const page = router.resolve({
        path: '/appStore'
      })

      setMsgList({
        content: `系统已发放给您1张优惠券${data?.couponName || ''}，有效期至${
          data?.expireTime || '-'
        }，请尽快到<a style="color: #5687ff;" href="${page?.href}" data-msgId=${
          '' + data.msgId
        } onclick="toOrderPay(event)">应用商城</a>使用。`,
        data: data,
        fn: () => {
          router.push('/appStore')
        },
        msgId: data.msgId,
        mainTitle: '客户通知',
        text
      })
    })
  }

  // CPS
  function listenCPS() {
    wsio.value.on(socketEmitStr.EVENTTYPE_220, (dataStr: any) => {
      console.log('cps', dataStr)
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        data: data,
        fn: () => {
          window.open('https://www.esign.cn')
        },
        msgId: data.msgId
      })
    })
  }

  // 代客下单成功通知消息
  function mallPlaceOrderNotice() {
    wsio.value.on(socketEmitStr.mall_place_order_notice, (dataStr: any) => {
      console.log('订单信息', dataStr)

      const data = JSON.parse(dataStr)
      console.log('订单信息', data)
      const text = '查看'
      const page = router.resolve({
        path: '/appStore',
        query: {
          activeName: 3
        }
      })
      console.log('订单跳转路径', page)
      usePayOrderInfo()?.refreshData(true)
      setMsgList({
        content: `${
          data?.content?.substring(data?.content?.indexOf('应用商城-订单管理-待支付'), 0) || ''
        }<a style="color: #5687ff;" data-msgId=${'' + data.msgId} data-mainOrderId=${
          '' + data.mainOrderId
        } href="${page?.href}" onclick="toOrderPay(event)">应用商城-订单管理-待支付</a>处支付。`,
        data: data,
        fn: () => {
          usePayOrderInfo()?.refreshData(true)
          if (data.mainOrderId) {
            usePayOrderInfo()?.setPayOrderId([data.mainOrderId])
          }
          router.push('/appStore?activeName=3')
        },
        msgId: data.msgId,
        text
      })
    })
  }
  // 监听银行卡支付成功等待银行的回调
  function mallOrderPayDoneNoticeNotice() {
    wsio.value.on(socketEmitStr.pay_done_notice, (dataStr: any) => {
      console.log('银行回调信息', dataStr)
      const data = JSON.parse(dataStr)
      if (data?.payResult === 'success') {
        ElMessage.success(data?.content || '支付成功，请耐心2-10分钟系统完成初始化')
      } else {
        ElMessage.error(data?.content || '支付失败')
      }
      usePayOrderInfo()?.setHasAcceptBankCallback(true)
    })
  }
  // 监听询单新增
  function inquiryManageAddNotice() {
    wsio.value.on(socketEmitStr.inquiry_manage_add, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        data: data,
        fn: () => {
          router.push(
            `/inquiryManageDetail?id=${data.objectId}&tableCode=${data.tableCode}&outPerms=true&realName=${data.realName}`
          )
        },
        msgId: data.msgId
      })
    })
  }

  function listenStaffUpload() {
    wsio.value.on(socketEmitStr.user_import_notice, (dataStr: any) => {
      console.log('下载失败咯', dataStr)

      const data = JSON.parse(dataStr)

      setMsgList({
        content: data.content,
        data: data,
        text: data.success ? '查看' : '下载导入失败数据',
        fn: () => {
          if (data.success) {
            router.push('/systemManage/userManage')
            MyGlobalEvent.$emit('refreshUserTable')
            // router.push({name: 'UserManage', params: { refresh: 'true'}})
          } else {
            downloadPersonUploadError(data.userImportErrorKey)
              .then(() => {
                ElMessage.success('下载成功！')
              })
              .catch(e => {
                ElMessage.error(e.message || '下载失败, 请联系管理员！')
              })
          }
        },
        msgId: data.msgId
      })
    })
  }

  function listenAddLayoutNotice() {
    wsio.value.on(socketEmitStr.add_layout_done_notice, (dataStr: any) => {
      setMsgList({
        content: dataStr,
        fn: () => {}
      })
    })
  }

  function listenAutoEventNotice() {
    wsio.value.on(socketEmitStr.auto_event_notify, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }
  // ERP-关联合作机构
  function listenErpRelate() {
    wsio.value.on(socketEmitStr.erp_relate_org, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }
  // 解除关联合作机构
  function listenErpUnRelate() {
    wsio.value.on(socketEmitStr.erp_un_relate_org, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }
  // 新建订单
  function listenErpNewOrder() {
    wsio.value.on(socketEmitStr.erp_new_order, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('IncomeOrdererp')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          temCache.saveData('IncomeOrdererpIntoId', data.intoId)
          router.push('/incomeOrdererp')
        }
      })
    })
  }
  // 资管明细新数据
  function listenErpAssetDetail() {
    wsio.value.on(socketEmitStr.erp_asset_detail_new, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('FundManageInfo')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          temCache.saveData('FundManageInfoTransformId', data.transformId)
          router.push('/fundManageInfo')
        }
      })
    })
  }
  // 通道费用阈值不足
  function listenErpChannel() {
    wsio.value.on(socketEmitStr.erp_channel_fee_threshold, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('AccountManage')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          router.push('/financial/accountManage?activeName=recharge')
        }
      })
    })
  }
  // 保证金额度不足
  function listenErpMargin() {
    wsio.value.on(socketEmitStr.erp_margin_threshold, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('AccountManage')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          router.push('/financial/accountManage?activeName=recharge')
        }
      })
    })
  }
  // 应收款一天后到期
  function listenErpReceivableOneDay() {
    wsio.value.on(socketEmitStr.erp_receivable_one_day, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('ReceivablesManage')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          router.push(`/receivablesManageDetail?id=${data?.objectId}`)
        }
      })
    })
  }
  // 应收款到期
  function listenErpReceivableExpire() {
    wsio.value.on(socketEmitStr.erp_receivable_expire, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('ReceivablesManage')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          router.push(`/receivablesManageDetail?id=${data?.objectId}`)
        }
      })
    })
  }
  // 应收款逾期
  function listenErpReceivableOverdue() {
    wsio.value.on(socketEmitStr.erp_receivable_overdue, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('ReceivablesManage')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          router.push(`/receivablesManageDetail?id=${data?.objectId}`)
        }
      })
    })
  }

  function listErpBalanceThreshold() {
    wsio.value.on(socketEmitStr.erp_balance_threshold, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  function listErpBalanceWarningThreshold() {
    wsio.value.on(socketEmitStr.erp_balance_warning_threshold, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 监听系统消息，提示用户刷新页面
  function listenSystemNotice() {
    wsio.value.on(socketEmitStr.socket_refresh_event, () => {
      refreshByNotice()
    })
  }
  const setTimeoutVal = ref<any>()
  // 手动刷新
  function refreshByNotice() {
    let countdown = 60
    const interval = ref<any>()
    interval.value = setInterval(() => {
      countdown--
      if (countdown === 0) {
        refreshNow()
      }
    }, 1000)
    ElMessageBox.confirm(h('div', '检测到系统配置更新，请刷新页面，以正常使用'), '系统通知', {
      confirmButtonText: '立即刷新',
      cancelButtonText: '稍后刷新'
    })
      .then(() => {
        refreshNow()
      })
      .catch(() => {
        // 重新更新倒计时，等一分钟之后弹出弹窗提示
        clearInterval(interval.value)
        clearTimeout(setTimeoutVal.value)

        setTimeoutVal.value = setTimeout(() => {
          refreshByNotice()
        }, 60 * 1000)
      })
    function refreshNow() {
      clearInterval(interval.value)
      clearTimeout(setTimeoutVal.value)
      location.reload()
    }
  }

  // 客户移交通知
  function listenTransferCusNotice() {
    wsio.value.on(socketEmitStr.handover_customers_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      const title = `${data?.operatorName}已将${data.count}个客户移交给你`
      setMsgList({
        content: title,
        fn: () => {
          if (data?.orderType === '1') {
            // 数据穿透到线索管理
            // 判断权限
            if (!getMenuAuth('ClueManage')) {
              ElMessage.error('暂无权限')
              return
            }
            temCache.saveData('clueParams', {
              chooseNum: data.count,
              title: `${data?.operatorName}移交的${data.count}个客户`,
              id: data?.objectId?.split?.(',') || []
            })
            router.push('/clueManage')
          } else {
            // 数据穿透到客户管理
            if (!getMenuAuth('CustomerManage')) {
              ElMessage.error('暂无权限')
              return
            }
            temCache.saveData('customerParams', {
              chooseNum: data.count,
              title: `${data?.operatorName}移交的${data.count}个客户`,
              id: data?.objectId?.split?.(',') || []
            })
            router.push('/customerManage')
          }
        }
      })
    })
  }
  // 主体机构认证审核通知
  function listenMainAuthNotice() {
    wsio.value.on(socketEmitStr.main_auth_notice, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          router.push('/accountConfig?activeName=second')
        },
        mainTitle: '机构主体审核消息'
      })
    })
  }

  // 客户数量上限
  function listenCustomer() {
    wsio.value.on(socketEmitStr.customer_equal_private, (dataStr: any) => {
      console.log('客户数量上限', dataStr)

      const data = JSON.parse(dataStr)

      setMsgList({
        content: data.content,
        fn: () => {},
        msgId: data.msgId,
        showCheck: 'false'
      })
    })
  }
  // 提前还款通知
  function listenEarlyRepay() {
    wsio.value.on(socketEmitStr.erp_early_repayment_info, (dataStr: any) => {
      console.log('提前还款通知', dataStr)
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          router.push('/earlyRepayment?earlyId=' + data.earlyId)
        },
        msgId: data.msgId,
        showCheck: 'true'
      })
    })
  }
  // 待办事项-任务中心消息推送
  function listenTaskCard() {
    wsio.value.on(socketEmitStr.task_card, (dataStr: any) => {
      const data = JSON.parse(dataStr)

      setMsgList({
        content: data.content,
        fn: () => {
          if (!getMenuAuth('TaskCenter')) {
            ElMessage.error('暂无权限，请联系管理员开通权限')
            return
          }
          router.push('/todoManage?currentMenuKey=TaskCenter')
        },
        msgId: data.msgId
      })
    })
  }
  // 唤起app呼叫-联系情况同步PC端
  function listenMobilePhoneRcCallMark() {
    wsio.value.on(socketEmitStr.evoke_mobile_phone_rc_call_mark, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      // 如果收到这个推送消息就刷新客户详情里面的联系情况
      // data格式 {1283147019866755072: 0}
      if (['/customerManage', '/clueManage'].includes(route.path)) {
        // 如果客户、线索管理就刷新列表
        MyGlobalEvent.$emit('refreshCustomerTable')
      } else if (['/customerDetail', '/clueDetail'].includes(route.path)) {
        // 如果客户、线索详情就刷新详情
        const customId: string = (!isEmptyObject(data) ? Object.keys(data)[0] : '') as string
        route.query?.id === customId && MyGlobalEvent.$emit('refreshCustomerDetail', customId)
      }
    })
  }
  // AI面签
  function listenAiSign() {
    wsio.value.on(socketEmitStr.ai_alarm, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {}
      })
    })
  }

  // 再次回访通知
  function listenRetunVisit() {
    wsio.value.on(socketEmitStr.return_visit_event, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          router.push(
            `/recycleBinDetail?id=${data.objectId}&realName=${data.customerName}&tableCode=${
              data.tableCode
            }&isReturnVisit=${1}&redirectUrl=visitBackManage&showCall=${getAuthByMenuCode(
              'Customer',
              'BACK_CALL'
            )}`
          )
        }
      })
    })
  }

  function listenOrderPhoneCheck() {
    wsio.value.on(socketEmitStr.order_phone_check, (dataStr: any) => {
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        data: data,
        fn: () => {
          router.push(`/trafficAlliance/invalidCustomerCheck`)
        },
        msgId: data.msgId
      })
    })
  }

  function listenCityPrice() {
    wsio.value.on(socketEmitStr.city_price, (dataStr: any) => {
      console.log(dataStr)
      const data = JSON.parse(dataStr)
      setMsgList({
        content: data.content,
        fn: () => {
          globalStore.setShowCityPriceDialog(true)
          globalStore.setCityPriceAdjustId(data?.objectId)
        },
        msgId: data.msgId
      })
    })
  }
  // 客户数据变更通知 被下方620替换
  function customerDataChangeNotice() {
    wsio.value.on(socketEmitStr.customer_data_change, (dataStr: any) => {
      const data = isJSON(dataStr) ? JSON.parse(dataStr) : dataStr
      setMsgList({
        content: data.content,
        data: data,
        fn: () => {
          // router.push(`/trafficAlliance/invalidCustomerCheck`)
        },
        msgId: data.msgId,
        showCheck: 'false'
      })
    })
  }

  // 协助人 620
  function listenCustomerDataChange() {
    wsio.value.on(socketEmitStr.customer_data_change, (dataStr: any) => {
      const data = isJSON(dataStr) ? JSON.parse(dataStr) : dataStr
      console.log(data, 'socket99999999999')
      setMsgList({
        text: '查看详情',
        // content: `${data.operatorName}已为您分派一个协助客户 ${data.realName} , 请及时跟进`,
        content: data.content,
        fn: () => {
          const msgData = {
            objectId: data.objectId,
            realName: data.customerName
          }
          // 客户详情
          jumpToCustomerDetail(msgData)
        }
      })
    })
  }

  // 人工单分配
  function listenaborClue() {
    wsio.value.on(socketEmitStr.labor_clue_allocate_notice, (dataStr: any) => {
      const data = isJSON(dataStr) ? JSON.parse(dataStr) : dataStr
      console.log(data, 'socket99999999999')
      setMsgList({
        text: '查看详情',
        // content: `${data.operatorName}已为您分派一个协助客户 ${data.realName} , 请及时跟进`,
        content: data.content,
        fn: () => {
          temCache.saveData('laborClueParams', {
            type: 3
          })
          router.push(`/manualOrder/moLeadManage?type=3&t=${+new Date()}`)
        }
      })
    })
  }

  return {
    messageTotalNum,
    initSocket,
    msgList,
    deleteMsgList,
    clearMsgList,
    closeSocket,
    listenAccount,
    closeListenAccount
  }
})
